import { SETTING_VALUE_CONSTRAINTS, SettingKey } from "@serophin/nottldr-shared";
import type { SettingsState } from "./useSettingsState";

const SPEEDS = SETTING_VALUE_CONSTRAINTS[SettingKey.AUDIO_SPEED];

/** The speed article audio starts at. */
export const SpeedSetting = ({ settings }: { settings: SettingsState }) => (
  <div class="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
    <div class="flex items-center justify-between mb-1">
      <h3 class="text-sm font-medium text-gray-900 dark:text-white">Playback speed</h3>
      <select
        value={settings.get(SettingKey.AUDIO_SPEED)}
        onChange={(event) => settings.change([{ key: SettingKey.AUDIO_SPEED, value: event.currentTarget.value }])}
        class="px-2 py-1 bg-white dark:bg-neutral-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
      >
        {SPEEDS.map((speed) => (
          <option key={speed} value={speed}>
            {speed}x
          </option>
        ))}
      </select>
    </div>
    <p class="text-xs text-gray-600 dark:text-gray-400">How fast articles are read to you.</p>
  </div>
);
